import { render, staticRenderFns } from "./UpdateVTokenModal.vue?vue&type=template&id=0ad081b4&scoped=true&"
import script from "./UpdateVTokenModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVTokenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad081b4",
  null
  
)

export default component.exports